export enum RoutePartCMRTypes {
    CMR = "CMR", 
    PortChart = "PortChart",
    none = "none"
}
